import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const getDefaultState = () => {
    return {
        view: {
            sidebarShow: 'responsive',
            sidebarMinimize: false,
        }
    }
}

const getters = {
    getViewSidebarShow: (state) => {
        return state.view.sidebarShow;
    },
    getViewSidebarMinimize: (state) => {
        return state.view.sidebarMinimize;
    },
}

const mutations = {
    toggleSidebarMobile (state) {
        const sidebarClosed = [false, 'responsive'].includes(state.view.sidebarShow);
        state.view.sidebarShow = sidebarClosed ? true : 'responsive';
    },
    setSidebarShow (state, [value]) {
        state.view.sidebarShow = value;
    },
    setSidebarMinimize (state, [value]) {
        state.view.sidebarMinimize = value;
    },
}

export default new Vuex.Store({
    state: getDefaultState(),
    getters,
    mutations,
})